export class ErrorResponse {
    constructor(public code: string,
                public status: number,
                public message: string,
                public errorList: Array<string>) {
    }

    toString(): string {
        return JSON.stringify(this);
    }
}